var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teaching-arrange-setting"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"main-cont"},[_c('TeachingArrangeSettingMain')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("排课通用设置")])])
}]

export { render, staticRenderFns }